
function installVueGlobal(Vue, globalName, globalValue) {
  const globalPrototype = Vue.version.slice(0, 2) === '3.' ? Vue.config.globalProperties : Vue.prototype;

  // Don't use Object.assign() to match the Vue.js supported browsers (ECMAScript 5)
  globalPrototype[globalName] = globalValue;
}

const numberFormat = {
  locale: 'de-DE',
  options: {
    currency: 'EUR'
  },
  toCurrency(value, currencyCode = 'EUR') {
    const currencyFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: currencyCode, minimumFractionDigits: 2 });
    return currencyFormatter.format(value);
  },
  toAmount(value) {
    const currencyFormatter =  new Intl.NumberFormat('de-DE',  { minimumFractionDigits: 2 })
    return currencyFormatter.format(value);
  },
  toDecimalFormat(value) {
    const currencyFormatter =  new Intl.NumberFormat('de-DE')
    return currencyFormatter.format(value);
  }

}

/* function formatCurrencyByCountry(amount, currency = 'EUR') {
  const formatter = new Intl.NumberFormat({
    style: 'currency',
    currency: currency,
  });

  return formatter.format(amount);
} */

export default function install(Vue, locale="de-DE", options={ currency: 'EUR'}) {
  
  numberFormat.locale = locale;
  numberFormat.currencyFormatter= new Intl.NumberFormat(locale, { style: 'currency', currency: options.currency, minimumFractionDigits: 2 });

  installVueGlobal(Vue, '$numberFormat', numberFormat);
}